import { getAreaCodes } from "@/services/intratone/areacode"

// initial state
const state = () => ({
    allCountriesCodesList: [],
})

// getters
const getters = {
    getGlobalApiVersion: (state) => {
        return state.globalApiVersion
    },

    getAllCountriesCodesList: (state) => {
        return state.allCountriesCodesList
    },
}

// actions
const actions = {
    updateGlobalApiVersion({ commit }, value) {
        commit("SET_GLOBAL_API_VERSION", value)
    },

    fetchAllCountriesCodeList({ state, commit }) {
        const fetchLimit = 100

        if (!state.allCountriesCodesList.length) {
            return getAreaCodes({
                order: "asc",
                all: 1,
                limit: fetchLimit,
            }).then(({ data: firstData, data: { _count } }) => {
                if (parseInt(_count) > fetchLimit) {
                    return getAreaCodes({
                        order: "asc",
                        all: 1,
                        limit: _count,
                    }).then(({ data: secondData }) => {
                        commit("SET_API_VERSION_COUNTRIES_CODES", secondData.v)
                        commit("SET_ALL_COUNTRIES_CODES_LIST", secondData.list)
                    })
                }

                commit("SET_API_VERSION_COUNTRIES_CODES", firstData.v)
                commit("SET_ALL_COUNTRIES_CODES_LIST", firstData.list)
            })
        }
    },
}

// mutations
const mutations = {
    SET_GLOBAL_API_VERSION(state, value) {
        state.globalApiVersion = value
    },

    SET_ALL_COUNTRIES_CODES_LIST(state, value) {
        state.allCountriesCodesList = value
    },

    SET_API_VERSION_COUNTRIES_CODES(state, value) {
        state.apiVersionCountriesCodes = value
    },
}

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
}
